'use strict';

/**
 * @ngdoc function
 * @name ntmAppDailyPlan.controller:DailyPlanController
 * @description
 * # DailyPlanController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('DailyPlanController', ['$scope', 'DailyPlanContext', 'Constants', '$location',
      function ($scope, DailyPlanContext, Constants, $location) {

      $scope.activityType = Constants.ActivityTypes;
      $scope.DailyPlan = new DailyPlanContext();

      $scope.DailyPlan.init();

      $scope.$on('$destroy', function () {
          $scope.DailyPlan.closeSignalRConnection();
      });

      var leavingConfirmed = false;

      $scope.$on('$locationChangeStart', function (event, newUrl) {
          if (!leavingConfirmed) {
              var target = $location.path();

              if ($scope.DailyPlan.TopBar.hasEmergencyChanges()) {
                  event.preventDefault(newUrl);

                  $scope.DailyPlan.TopBar.confirmViewLeaving(function () {
                      leavingConfirmed = true;
                      $location.path(target);
                  });
              } else if ($scope.DailyPlan.CurrentView.isChanged()) {

                  if (newUrl.indexOf('dailyPlan') === -1) {
                      event.preventDefault(newUrl);

                      $scope.DailyPlan.CurrentView.confirmViewLeaving(function () {
                          $scope.DailyPlan.TopBar.BreadCrumbs.clearSearchParams();
                          leavingConfirmed = true;
                          $location.path(target);
                      });
                     
                  }
              } else {
                  if (newUrl.indexOf('dailyPlan') === -1) {
                      $scope.DailyPlan.TopBar.BreadCrumbs.clearSearchParams();
                  }
              }
          }
      });
}]);
